<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title">
          {{ $t("Seat Class Wise Summary Report") }}
        </div>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                        ✖
                      </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                        ✖
                      </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>

  
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="GetSeatClassWiseSalesSummaryReport('N','N', '')"
              >
                {{ $t("fetch") }}
                {{ $t("report") }}
              </button>
            </div>

            
            <div class="col-lg-6 col-xl-3 align-self-center mb-0">
                <div class="dropdown-curve-container">
              
                  <multiselect
                  :disabled="isRoleID"
                :options="screenList"
                v-model="selectedScreen"
                :searchable="true"
                label="screen_name"
                track-by="screen_id"
                placeholder="Select Voucher"            
                :showLabels="false"
                :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>
          </div>
        </div>
  
        <div
        v-if="screenWiseData.length > 0"
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->

          <a target="_blank" 
          @click="GetSeatClassWiseSalesSummaryReport('Y', 'N','')" 
          title="Download as Excel" 
          download>
          <img 
          src="@/assets/img/icons/excel.svg" 
          height="25"
           width="25" />
        </a>

          <a
            target="_blank"
            @click="GetSeatClassWiseSalesSummaryReport('N','Y','')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
  
        <div>
          <div class="table-scroll">           
            <table
              class="swc-report-table performance-report-table"
              border="1"
              v-if="screenWiseData.length > 0"
            >
              <thead class="bg-lightgrey">
                <tr>
                  <th rowspan="2">Screen No. and Seat Type</th>
                  <th colspan="">Sold No.</th>
                </tr>
              </thead>
              <template
              v-for= "(categoryData, categoryIndex) in screenWiseData"
              >
                <tr  class="distName" style="background-color: #E8E8E8">
                  <th class="text-left " colspan="2"  >
                    {{ categoryData.screen_name }}
                  </th>
                </tr>
                <template 
                v-for= "(screenData, screenIndex) in categoryData.data"
               >
                  <tr >
                    <td class="text-left">
                        {{screenData.seat_type_name}}
                    </td>
                    <td class="text-right">
                        {{screenData.SoldNo}}
                    </td>
                  </tr>
                </template >
  
                <tr  class="concession_blue">
                  <td colspan="" class="text-left font-weight-bold" >{{categoryData.screen_name}} Total</td>
                  <td class="text-right font-weight-bold">
                    {{
                    categoryData.data
                      .reduce((acc, { SoldNo }) => {
                        return acc + SoldNo;
                      }, 0)
                     
                  }}
                  </td>
                </tr>
              </template>
              <thead class="bg-lightgrey">
                <tr>
                  <th class="text-left" colspan="">Grand Total</th>
                  <th class="text-right">{{grandTotal.SoldNoForScreenData}} </th>
                </tr>
              </thead>
            </table>
          </div> 
          <!-- --------------------------------------- -->
          <div class="table-scroll mt-5" >           
            <table
              class="swc-report-table performance-report-table"
              border="1"
              v-if="screenWiseData.length > 0"
            >
              <thead class="bg-lightgrey">
                <tr>
                 
                  <th colspan="2">Summary</th>
                </tr>
              </thead>
              <template
              v-for= "(categoryData, categoryIndex) in summaryData" 
              >
                <tr class="distName" >
                  <th v-for= "(data, categoryIndex) in categoryData.data" class="text-left "   >
                    {{ data.seat_type_name }}
                  </th>
                  <th v-for= "(data, categoryIndex) in categoryData.data" class="text-right "  >
                    {{data.SoldNo}}
                  </th>
                </tr>          
              </template>
              <thead class="bg-lightgrey">
                <tr>
                  <th class="text-left" colspan="">Grand Total</th>
                  <th class="text-right">{{grandTotal.SoldNoForScreenData}} </th>
                </tr>
              </thead>
            </table>
          </div> 
        </div>
      <table
          
          class="swc-report-table swc_table_header table-scroll"
          border="1"
          v-if="screenWiseData.length === 0"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th rowspan="2">Seat No.</th>
                  <th colspan="">Seat Type</th>
                </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
    
    <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        htmlToPdfOptions: {
          filename: this.pdfFileName,
          margin: 3,
          image: {
            type: "jpeg",
            quality: 1,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        screenWiseData: [],
       grandTotal : {},
       summaryData : [],
      screenList:[],
      selectedScreen : [],
      
      
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
    },
    watch: {
      toDate(newToDate, oldToDate) {
    if (this.toDate && newToDate) {
      this.GetSeatClassWiseSalesSummaryReport('N', 'N', 'filter');
  }
}
    },
    mounted() {},
    methods: {
      moment,
      getCinemaList: function () {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.GetSeatClassWiseSalesSummaryReport('N','N','filter')
        this.$store.dispatch("selectDropdownCinema", event);
      },
      GetSeatClassWiseSalesSummaryReport(isExcel= "N",isPdf = "N",type = "") {
        this.screenWiseData = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
          type: type || "",
        };

        if(this.selectedScreen.length > 0 ){
        payload.screen_id= this.selectedScreen.map(voucher => voucher.screen_id);
        
      }
        ReportsService.GetSeatClassWiseSalesSummaryReport(payload)
          .then((response) => {
            const { data } = response;   
            
            if (data.status ) {
              if (type == "filter") {
        this.screenList = data.Records;
      } else{
        this.screenWiseData = [...data.Records];
               this.summaryData = [...data.summaryData]
              console.log("summaryData", this.summaryData)

              this.grandTotal = data.grandTotal
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if ((isExcel == "Y" && data.excelPath)) {
              window.open(data.excelPath, "_blank");
            }
      }
             
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
  </script>
    
    <style>

  
 .concession_blue {
  background-color: #c5d6f0 !important;
}
  </style>
    


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/seatClassWiseSalesSummary.vue